import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import {
  AdSlotContainer,
  StyledSlot,
} from "scmp-app/components/advertisement/ad-slots/ad-slot/styles";
import { ContentItemArticleWidget } from "scmp-app/components/content/content-item-render/variants/article-widget";
import { EntityLink } from "scmp-app/components/entity-link";
import { HomeFollowButton } from "scmp-app/components/home/follow-button";
import {
  StyledDesktopEntityFollowButton,
  StyledMobileEntityFollowButton,
} from "scmp-app/components/home/follow-button/styles";
import { StyledButton } from "scmp-app/scmp-sdk/components/follow-button/styles";

export const Divider = styled.div`
  inline-size: 100%;
  block-size: 1px;
  margin-block: 16px;

  background: #333333;
`;

export const StyledHomeFollowButton = styled(HomeFollowButton)<{ $isFollowed: boolean }>`
  display: flex;

  min-inline-size: max-content;
  ${StyledMobileEntityFollowButton} {
    display: block;
  }
  ${StyledDesktopEntityFollowButton} {
    display: none;
  }

  ${StyledButton} {
    ${props =>
      !props.$isFollowed &&
      `
      color: #2c4692;
      border-color: #788ac4;
    `}

    svg {
      path {
        fill: #2c4692;
      }
    }
  }
`;

export const StyledContentItemArticleWidget = styled(ContentItemArticleWidget)``;

export const Container = styled.div`
  inline-size: 300px;
  block-size: 100%;
  min-inline-size: 295px;
  padding: 16px;

  font-family: ${fontRobotoCondensed};

  border: 1px solid #dfdfdf;
  border-radius: 8px;

  background: #ffffff;

  ${theme.breakpoints.up("desktop")} {
    block-size: unset;
  }
`;

export const Header = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;
`;

export const TopicContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  margin-block: 4px 8px;
  padding-block-end: 8px;
  border-block-end: 1px solid #333333;
`;

export const Topic = styled.div`
  flex: 1;

  line-height: 19px;
`;

export const TopicName = styled(EntityLink)`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
`;

export const ContentContainer = styled.div`
  ${StyledContentItemArticleWidget}:not(:last-child) {
    margin-block-end: 8px;
    padding-block-end: 12px;
    border-block-end: 1px solid #dfdfdf;
  }
`;

export const AdSlot = styled.div`
  && ${AdSlotContainer} {
    display: flex;
    align-items: flex-start;

    block-size: 100%;
    margin-block-start: 12px;

    ${StyledSlot} {
      block-size: auto;
    }
  }
`;
